import { Observable, pipe, of, forkJoin } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Fetch } from '@app/models/fetch';
import { Cache } from '@app/models/cache';
import { Device } from '@app/models/devices/devices.model';
import { config } from '@config/config';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
import * as i2 from "../cache";
var DeviceService = /** @class */ (function () {
    function DeviceService(fetch, cache) {
        this.fetch = fetch;
        this.cache = cache;
        this.baseUrl = '/devices';
        this.cacheName = 'devices';
        this.cache.register(this.cacheName, Device, 60);
    }
    DeviceService.prototype.get = function (id) {
        return this.cache.getOne(this.cacheName, id, this.fetch.getOne(this.baseUrl, id));
    };
    DeviceService.prototype.getFromLocation = function (loc) {
        return this.cache
            .getAll(this.cacheName, this.fetch.getAll(this.baseUrl, { list_shared: true }))
            .pipe(map(function (models) { return ({
            br: models.find(function (dev) { return dev.location_id === loc.id && dev.type === config.deviceTypes.BRIDGE; }),
            ws: models.find(function (dev) { return dev.location_id === loc.id && dev.type === config.deviceTypes.WS; }),
        }); }));
    };
    DeviceService.prototype.getAll = function () {
        return this.cache.getAll(this.cacheName, this.fetch.getAll(this.baseUrl));
    };
    DeviceService.prototype.joinNotifications = function (notifs) {
        return this.fetch
            .getSome(this.baseUrl, notifs.map(function (notif) { return notif.device_id; }))
            .req.pipe(map(function (devices) {
            for (var i = 0; i < notifs.length; i++) {
                notifs[i].device = devices[i];
            }
            return notifs;
        }));
    };
    DeviceService.prototype.joinNotificationsPipe = function () {
        var _this = this;
        return pipe(switchMap(function (notifs) {
            if (notifs.length === 0) {
                return of(notifs);
            }
            return _this.joinNotifications(notifs);
        }));
    };
    DeviceService.prototype.joinLocations = function (locs) {
        var _this = this;
        return forkJoin(locs.map(function (loc) {
            return _this.getFromLocation(loc).pipe(map(function (devs) {
                loc.bridge = devs.br;
                loc.ws = devs.ws;
                return loc;
            }));
        }));
    };
    DeviceService.prototype.joinLocationPipe = function () {
        var _this = this;
        return pipe(switchMap(function (loc) { return _this.joinLocations([loc]); }), map(function (loc) { return loc[0]; }));
    };
    DeviceService.prototype.joinLocationsPipe = function () {
        var _this = this;
        return pipe(switchMap(function (locs) { return _this.joinLocations(locs); }));
    };
    DeviceService.prototype.getDeviceType = function (id) {
        return this.get(id).pipe(map(function (device) { return device; }));
    };
    DeviceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeviceService_Factory() { return new DeviceService(i0.ɵɵinject(i1.Fetch), i0.ɵɵinject(i2.Cache)); }, token: DeviceService, providedIn: "root" });
    return DeviceService;
}());
export { DeviceService };
